import { Toast, ToastType } from '@/hooks/useToast';

interface ToastContainerProps {
  toasts: Toast[];
  onRemove: (id: string) => void;
}

const iconMap: Record<ToastType, string> = {
  success: 'ri-check-line',
  error: 'ri-close-line',
  warning: 'ri-alert-line',
  info: 'ri-information-line',
};

const colorMap: Record<ToastType, { bg: string; icon: string }> = {
  success: { bg: 'bg-green-500', icon: 'text-white' },
  error: { bg: 'bg-red-500', icon: 'text-white' },
  warning: { bg: 'bg-yellow-500', icon: 'text-white' },
  info: { bg: 'bg-orange-500', icon: 'text-white' },
};

export default function ToastContainer({ toasts, onRemove }: ToastContainerProps) {
  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[70] flex flex-col gap-2 items-center pointer-events-none">
      {toasts.map((toast) => {
        const colors = colorMap[toast.type];
        const icon = iconMap[toast.type];
        return (
          <div
            key={toast.id}
            className="flex items-center gap-3 bg-slate-900 text-white px-5 py-3.5 rounded-2xl min-w-[280px] max-w-sm pointer-events-auto animate-[slideUp_0.35s_ease-out]"
          >
            <div className={`w-8 h-8 ${colors.bg} rounded-full flex items-center justify-center flex-shrink-0`}>
              <i className={`${icon} ${colors.icon} text-base`}></i>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold leading-tight">{toast.message}</p>
              {toast.description && (
                <p className="text-xs text-slate-400 mt-0.5 leading-tight">{toast.description}</p>
              )}
            </div>
            <button
              onClick={() => onRemove(toast.id)}
              className="ml-1 w-6 h-6 flex items-center justify-center text-slate-400 hover:text-white transition-colors flex-shrink-0 cursor-pointer"
            >
              <i className="ri-close-line text-sm"></i>
            </button>
          </div>
        );
      })}
    </div>
  );
}
